/* tslint:disable:max-line-length */
import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    PLATFORM_ID,
    ViewChild,
} from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";

import { Observable } from "rxjs";

import { VenueService } from "../venue.service";
import { VenueData } from "../../shared/model/venue";
import { Pitch } from "../../shared/model/pitch";
import { SearchListLinkService } from "./../../shared/search.list.link.service";
import { ModalService, IBadge, mlpEmailValidator } from "pf_styleguide";
import { ContactDetailsService } from "./../../shared/module/contact-details/contact.details.service";
import { ApiEndpoints } from "./../../shared/apiEndpoints";
import { PitchCollection } from "app/shared/model/pitchCollection";
import { Venue } from "./../../shared/model/venue";
import { SearchService } from "app/search-results/search.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MandrillService } from "app/partner/mandrill.service";
import { CLAIM_VENUE_TEMPLATE, CONTACT_VENUE_FAIL_TEMPLATE, CONTACT_VENUE_SUCCESS_TEMPLATE, NotifyMePayload } from "app/shared/model/venue-content.interface";
import { contactVenuePayload, notifyMePayload } from "app/shared/model/venue-content.data";
import { EventTrackingService } from "app/shared/eventTracking.service";
import { GenericService } from "app/shared/generic.service";
import { ConfigureService } from "app/configure/configure.service";
import { MandrillEmailTemplate } from "app/shared/model/mandrillEmailTemplate";
import { MandrillEmailRecipient } from "app/shared/model/mandrillEmailRecipient";
import { finalize } from "rxjs/operators";
import { CustomValidators } from "app/shared/validator/customValidators";

@Component({
    selector: "mlp-venue-content",
    templateUrl: "venue-content.component.html",
    styleUrls: ["./venue-content.component.scss"],
})
export class VenueContentComponent implements OnInit {
    @ViewChild("contactVenueModal") contactVenueModal: ElementRef;
    @ViewChild("contactVenueFormModal") contactVenueFormModal: ElementRef;
    @ViewChild("claimVenueFormModal") claimVenueFormModal: ElementRef;

    public similarPitchData: Array<{ pitch: Pitch; venue: Venue }> = null;
    public similarPitchesDisplayCount = 3;
    pitchesWithUniqueSports: Array<Pitch> = [];
    sport = "";
    city = "";
    route$: Observable<ParamMap>;
    isBrowser: boolean = isPlatformBrowser(this.platformId);
    modalMobile = {
        size: "sm",
        keyboard: false,
    };
    statusBadge: IBadge;
    activePlaces: 'active_places';

    @Input() openMapEvent = new EventEmitter();
    @Input() pitchesWithSameSport: Array<Pitch> = [];

    public formGroup:FormGroup;
    public isLoading:boolean;
    public success:boolean;
    public submitted:boolean;
    public claimVenueFormGroup:FormGroup;
    
    constructor(
        public venueService: VenueService,
        private route: ActivatedRoute,
        protected router: Router,
        public modalService: ModalService,
        public searchListLinkService: SearchListLinkService,
        private contactService: ContactDetailsService,
        public apiEndpoints: ApiEndpoints,
        public searchService: SearchService,
        @Inject(PLATFORM_ID) private platformId,
        private cdef: ChangeDetectorRef,
        public fb: FormBuilder,
        protected config: ConfigureService,
        protected eventTrackingService: EventTrackingService,
        protected genericService: GenericService,
        protected mandrillService: MandrillService
    ) {
        
        this.venueService.pitchDataChange.subscribe(() => {
            this.sport = this.venueService.pitchData.data.attributes.sport;
            
            this.contactService.isMLP =
                this.venueService.pitchData.data.attributes.mlp;
            this.contactService.checkIsVisible();
        });

        this.venueService.venueDataChange.subscribe((data: VenueData) => {
            this.filterUniqueSports(data.included);
        });

        this.formGroup = this.fb.group({
            email: ['',[Validators.required,Validators.email]]
        });

        this.claimVenueFormGroup = this.fb.group({
            fullName: [undefined],
            email: [undefined, [Validators.required, mlpEmailValidator()]],
            phoneNumber: [
                undefined,
                [CustomValidators.phoneNumber()],
            ],
            role: [undefined],
            message: [undefined, [Validators.required]],
        });
        this.isLoading = false;
    }

    ngOnInit(): void {
        this.route$ = this.route.paramMap;
        this.route$.subscribe((params: ParamMap) => {
            this.city = params.get("city");
        });

        if (this.venueService.pitchData) {
            this.sport = this.venueService.pitchData.data.attributes.sport;
            this.filterUniqueSports(this.venueService.venueData.included);
        }
    }

    lowercase(value: string): string {
        if (value) {
            return value.toLowerCase();
        }
    }

    viewSearchResults(): void {
        if (
            this.venueService.pitchData &&
            this.venueService.venueData &&
            this.city
        ) {
            if (!this.searchListLinkService.wasSearchResultsPage) {
                this.router.navigate(
                    [
                        this.city,
                        "results",
                        this.venueService.pitchData.data.attributes.sport.replace(
                            /\s+/g,
                            "-"
                        ),
                    ],
                    {
                        queryParams: {
                            latitude:
                                this.venueService.venueData.data.attributes
                                    .latitude,
                            longitude:
                                this.venueService.venueData.data.attributes
                                    .longitude,
                            radius: "5mi",
                            formats:
                                this.venueService.pitchData.data.attributes
                                    .format,
                            surfaces:
                                this.venueService.pitchData.data.attributes
                                    .surface,
                        },
                    }
                );
            }

            if (this.searchListLinkService.wasSearchResultsPage) {
                this.searchListLinkService.backInHistory();
            }
        }
    }

    private filterUniqueSports(pitches: Array<Pitch>): void {
        this.pitchesWithUniqueSports = [];

        pitches.forEach((pitchData: Pitch) => {
            let sportFound = false;

            this.pitchesWithUniqueSports.forEach((existingPitch: Pitch) => {
                if (
                    existingPitch.attributes.sport ===
                    pitchData.attributes.sport
                ) {
                    sportFound = true;
                }
            });

            if (!sportFound) {
                this.pitchesWithUniqueSports.push(pitchData);
            }
        });
    }

    openContactVenueModal() {
        if(!this.similarPitchData) {
            this.apiEndpoints
            .callMlpApiGetPitchCollectionFromLocation(this.venueService.pitchData, 6, 1)
            .subscribe(
                (pitches: PitchCollection) => {
                    this.similarPitchData = [];

                    pitches.data.forEach((pitch: Pitch) => {
                        if (pitch.id != this.venueService.pitchData.data.id) {
                            let venueFound;

                            pitches.included.forEach((venue: Venue) => {
                                if (
                                    venue.id ==
                                    pitch.relationships.venues.data.id
                                ) {
                                    venueFound = venue;
                                }
                            });

                            this.similarPitchData.push({
                                pitch: pitch,
                                venue: venueFound,
                            });
                        }
                    });

                    this.modalService
                        .open(this.contactVenueModal, {size: 'lg'})
                }
            );
        } else {
            this.modalService.open(
                this.contactVenueModal, { size: 'lg' }
            )
        }
        
    }

    milesAway(venue: Venue): string {
        const dist = this.getDistanceFromLatLonInMiles(
            this.venueService.venueData.data.attributes.latitude,
            this.venueService.venueData.data.attributes.longitude,
            venue.attributes.latitude,
            venue.attributes.longitude
        );

        const distRounded = Math.round(dist * 10 + Number.EPSILON) / 10;

        return !isNaN(distRounded)
            ? `${distRounded} ${distRounded === 1 ? "mile" : "miles"} away`
            : "";
    }

    private getDistanceFromLatLonInMiles(lat1, lon1, lat2, lon2): number {
        let mileConversion = 0.621371;
        let earthRadius = 6371; // Radius of the earth in km
        let dLat = this.deg2rad(lat2 - lat1);
        let dLon = this.deg2rad(lon2 - lon1);
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(lat1)) *
                Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return earthRadius * c * mileConversion;
    }

    private deg2rad(deg) {
        return deg * (Math.PI / 180);
    }

    areAvailableSlots(pitch: Pitch): boolean {
        return !!(
            pitch.attributes.online_booking &&
            pitch.attributes.available_slots_total
        );
    }

    resetForm(form: FormGroup) {
        this.isLoading = false;
        this.success = false;
        this.submitted = false;
        form.reset();
        form.markAsPristine();
        form.markAsUntouched();
        form.updateValueAndValidity();
    }

    openContactVenueFormModal() {
        this.modalService.close();
        this.resetForm(this.formGroup);
        this.modalService
            .open(
                this.contactVenueFormModal, { size: 'lg' })
    }

    getVenueDataFromPitch(): Venue {
        let venueData: Venue = null;

        if(!this.venueService.pitchData) {
            return;
        }

        this.venueService.pitchData.included.forEach((venue: Venue) => {
            if (this.venueService.pitchData.data.relationships.venues.data.id == venue.id) {
                venueData = venue;
            }
        });

        return venueData;
    }

    validContactDetails(): boolean {
        const venue = this.getVenueDataFromPitch();
        return venue && venue.attributes.show_phone && !venue.attributes.contact_number.includes('000000');
    }

    notifyMe() {
        this.submitted = true;
        if(this.formGroup.valid){
            const email = this.formGroup.get('email').value;
            const payload:NotifyMePayload = notifyMePayload;
            payload.data.attributes.email = email;
            payload.included[0].attributes.value = this.venueService.venueData.data.id;
            this.isLoading = true;
            this.apiEndpoints
                .notifyMe(payload)
                .pipe(finalize(()=> (this.isLoading = false)))
                .subscribe((data) => {
                    this.success = true;
                });
        }
        
    }

    sendVenueContactStatus(status: boolean) {
        const payload = contactVenuePayload;
        payload.data.attributes = {
            venue: this.getVenueDataFromPitch().id,
            contacted: status,
        };
        this.isLoading = true;
        this.apiEndpoints
            .contactedVenue(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((_) => {
                this.eventTrackingService.trackEvent(
                    "Contact Message Sent",
                    this.getEventTrackingActionName(),
                    "Contact Message Sent"
                );
                this.success = true;
            });
    }

    getEventTrackingActionName(): string {
        return "Contact Venue";
    }

    get email(): FormControl {
        return this.formGroup.get("email") as FormControl;
    }
    get fullName(): FormControl {
        return this.claimVenueFormGroup.get("fullName") as FormControl;
    }
    get claimVenueEmail(): FormControl {
        return this.claimVenueFormGroup.get("email") as FormControl;
    }
    get phoneNumber(): FormControl {
        return this.claimVenueFormGroup.get("phoneNumber") as FormControl;
    }
    get role(): FormControl {
        return this.claimVenueFormGroup.get("role") as FormControl;
    }
    get message(): FormControl {
        return this.claimVenueFormGroup.get("message") as FormControl;
    }

    openClaimVenueModal() {
        this.resetForm(this.claimVenueFormGroup);
        this.modalService
            .open(
                this.claimVenueFormModal, 
                {
                    size: 'lg'
                }
            )
    }

    getVerified() {
        if(!this.claimVenueFormGroup.valid) {
            return;
        }
        const emailRecipient = new MandrillEmailRecipient(this.claimVenueEmail.value);
    
        const mandrillEmailTemplate = new MandrillEmailTemplate(
                CLAIM_VENUE_TEMPLATE,
                [emailRecipient],
                [
                    { name: "fullName", content: this.fullName.value },
                    { name: "email", content: this.claimVenueEmail.value },
                    { name: "phoneNumber", content: this.phoneNumber.value },
                    { name: "role", content: this.role.value },
                    { name: "message", content: this.message.value },
                    { name: 'venueName', content: this.venueService.venueData.data.attributes.name }
                ],
                this.config
            );
        this.isLoading = true;
        this.mandrillService
            .sendTemplate(mandrillEmailTemplate)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((data) => {
                this.eventTrackingService.trackEvent(
                    "Claim Venue Message Sent",
                    "Claim Venue",
                    "Claim Venue Message Sent"
                );
                this.success = true;
            });
    }

    scrollToTheTop(): void {
        window.scrollTo(0, 0);
    }
}
